<template>
    <v-container class="pa-md-12 pa-sm-6" fluid color="green-lighten-2">
      <v-responsive
        class="my-16"
        max-width="900"
      >

        <h1 class="font-weight-bold mb-16 text-h5 text-sm-h4">
          {{ title }} 
        </h1>
  
        <v-btn
          class="mr-4 text-none"
          color="#0071E3"
          size="large"
          height="7vh"
          variant="flat"
          @click="navigate"
          :text="btext"
          :href="link"
          :route="route"


        />

        <div :v-if="!btext2">
  
        <v-btn
        v-if="btext2"
          xappend-icon="mdi-arrow-right"
          class="text-none"
          size="small"
          variant="text"
          width="30vw"
          height="7vh"
          :text="btext2"
          :href="link2"
          @click="navigate"
          :route="route"



        />
      </div>
      </v-responsive>
    </v-container>
  </template>

<script setup>



import { useRouter } from "vue-router";

const router = useRouter();

const navigate = () => {
  if (props.route) {
    router.push({ name: props.route });
  }
};

defineProps([
  "img",
  "title",
  "description",
  "Q",
  "btext",
  "btext2",
  "link",
  "link2"
]);

</script>